import { auditFields, operations, types } from '../common';

/**
 * Entity schema
 */
const schema = {
  version: 3,

  title: 'Request',
  description: 'Blood product request from blood banks',

  primaryKey: 'id',
  type: 'object',
  properties: {
    id: types.ID,
    icode: types.STRING_INDEX,

    dueTime: types.DATE_TIME_INDEX,
    priority: types.STRING_INDEX, // category
    status: types.STRING_INDEX, // action
    quantity: types.NUMBER,
    details: types.STRING,

    bloodType: types.STRING_INDEX, // blood type
    bloodProductType: types.OBJECT,
    bloodBank: types.OBJECT,

    // Audit fields
    ...auditFields
  },

  required: ['id', 'dueTime', 'priority', 'status', 'quantity', 'bloodProductType', 'bloodBank'],
  indexes: [
    ['dueTime'],
    ['priority'],
    ['status']
  ],
  keyCompression: true
};

/**
 * Migration strategies
 */
const migrationStrategies = {};

/**
 * Collection methods
 */
const statics = {
  /**
   * Creates new instance
   *
   * Also updates full and person names
   *
   * @param {object} data  New instance
   * @returns Promise
   */
  add: function (data) {
    return operations.add(this, data);
  },

  /**
   * Updates instance
   *
   * Also updates full and person names
   *
   * @param {object} data  Instance
   * @returns Promise
   */
  edit: function (data) {
    return operations.edit(this, data);
  },

  /**
   * Deletes instance
   *
   * @param {string} id  Instance ID
   * @returns Promise
   */
  del: function (id) {
    return operations.del(this, id);
  }
};

/**
 * Instance methods
 */
const methods = {};

/**
 * Collection definition
 */
const collection = { schema, migrationStrategies, statics, methods };

export default collection;
